import CheckIcon from "../../../../../assets/svg/check-icon";
import { useFilterPortalPosition } from "../../../../Crm/components/KanbanGrid/components/tableFilters/useFilterPortalPosition";
import { createPortal } from "react-dom";
import { SegmentTypeFilterProps } from "../types/segments.types";
import { SEGMENT_TYPE_OPTIONS } from "../constants/segments.constants";

const SegmentTypeFilter = ({
  selectedType,
  onSelect,
  onClose,
  triggerRef,
}: SegmentTypeFilterProps) => {
  const pos = useFilterPortalPosition(triggerRef);

  const handleSelect = (
    value: (typeof SEGMENT_TYPE_OPTIONS)[number]["value"]
  ) => {
    onSelect(value);
    onClose();
  };

  const handleOptionClick = (
    e: React.MouseEvent,
    value: (typeof SEGMENT_TYPE_OPTIONS)[number]["value"]
  ) => {
    e.stopPropagation();
    handleSelect(value);
  };

  if (!pos) return null;

  return createPortal(
    <div
      data-table-filter-dropdown
      className="fixed z-[20001] rounded-[8px] border border-border-gray dark:border-border-gray-dk bg-popper-bg/80 dark:bg-popper-bg-dk/80 backdrop-blur-[20px] shadow-[10px_10px_60px_0px_rgba(0,0,0,0.2)] p-[6px] w-[200px]"
      style={{ top: pos.top, left: pos.left }}
    >
      <div className="flex flex-col gap-1">
        {SEGMENT_TYPE_OPTIONS.map((option) => (
          <button
            key={option.value}
            className={`flex items-center justify-between px-[12px] py-[8px] rounded-[6px] cursor-pointer w-full ${
              selectedType === option.value
                ? "bg-hover-effect dark:bg-hover-effect-dk"
                : "hover:bg-hover-effect dark:hover:bg-hover-effect-dk"
            }`}
            onClick={(e) => handleOptionClick(e, option.value)}
          >
            <div className="flex items-center gap-[6px]">
              {option.dotColor && (
                <div
                  className={`w-[6px] h-[6px] rounded-full ${option.dotColor}`}
                />
              )}
              <span className="text-md font-normal text-heading-text dark:text-heading-text-dk whitespace-nowrap">
                {option.label}
              </span>
            </div>
            {selectedType === option.value && (
              <CheckIcon className="w-[16px] h-[16px] text-verba-blue dark:text-verba-blue-dk shrink-0" />
            )}
          </button>
        ))}
      </div>
    </div>,
    document.body
  );
};

export default SegmentTypeFilter;
